// Trajet d'un camion Teiu → livraison, pour la carte et la carte « Sur la route ».
// Départ le jour du chargement à 8 h, arrivée le jour de livraison estimée à 18 h.
// Livraison estimée = délai de transit saisi dans l'ERP (transport.delivery_date) ;
// sans délai, durée estimée d'après la distance (route ≈ 1,25 × vol d'oiseau,
// 700 km par jour), sinon 3 jours.

export const FACTORY = { lat: 45.895342, lng: 22.5019217 } // XYLO, Teiu (RO)

const ROAD_FACTOR = 1.25
const KM_PER_DAY = 700
const DEFAULT_DAYS = 3
const DAY = 86400000

function distanceKm (a, b) {
  const rad = x => (x * Math.PI) / 180
  const dLat = rad(b.lat - a.lat)
  const dLng = rad(b.lng - a.lng)
  const h = (Math.sin(dLat / 2) ** 2) + (Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * (Math.sin(dLng / 2) ** 2))
  return 2 * 6371 * Math.asin(Math.sqrt(h))
}

function hasCoords (p) {
  return !!p && Number.isFinite(p.lat) && Number.isFinite(p.lng)
}

/** { start, end } en ms, ou null sans date de chargement. `dest` = { lat, lng } de la livraison. */
export function tripWindow (transport, dest) {
  if (!transport || !transport.loading_date) return null
  const start = new Date(`${transport.loading_date}T08:00:00`).getTime()
  if (transport.delivery_date) {
    return { start, end: new Date(`${transport.delivery_date}T18:00:00`).getTime() }
  }
  let days = DEFAULT_DAYS
  if (hasCoords(dest)) days = Math.max(1, Math.ceil((distanceKm(FACTORY, dest) * ROAD_FACTOR) / KM_PER_DAY))
  return { start, end: start + (days * DAY) + (10 * 3600000) }
}

/** Part du trajet faite, 0 → 100 (0 avant le départ, 100 une fois arrivé). */
export function tripProgress (transport, dest, now = Date.now()) {
  const w = tripWindow(transport, dest)
  if (!w) return null
  if (w.end <= w.start) return 100
  return Math.max(0, Math.min(100, Math.round(((now - w.start) / (w.end - w.start)) * 100)))
}
